import { GET, PATCH, POST } from "../../../../../helper/xbi4RestFunctions";
export const createPersonalQueryResponse = async (
  org_id: any,
  org_user_id: any,
  pq_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/personal_queries/${pq_id}/reply`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
// org_id=path_param.get('org_id'),
// org_user_id=path_param.get('org_user_id'),
// pf_id=path_param.get('pq_id'),
// response=body.get("response"),
